import { render, staticRenderFns } from "./Toy.vue?vue&type=template&id=3d9b38f3&lang=pug&"
import script from "./Toy.vue?vue&type=script&lang=js&"
export * from "./Toy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports